module.exports = __webpack_public_path__ + "static/media/circle-dollar.18f513e2.png";